import UIActionTypes from './ui.types';

export const toggleSidebar = () => ({
  type: UIActionTypes.TOGGLE_SIDEBAR
});

export const openSidebar = () => ({
  type: UIActionTypes.OPEN_SIDEBAR
});
